import React, { FC, Suspense } from 'react';
import { Route, Switch, withRouter, Redirect, useLocation } from 'react-router-dom';
import { RouterProps } from 'router/routeUrl';
import Loading from 'components/Loading';
import BaseLayout from 'components/BaseLayout';
import ArcadeLayout from 'components/ArcadeLayout';
import Error404 from '../Error404/index';
import { getAllSupportedLanguageCodes } from 'utils/language';
import { getLanguageFromPath, addLanguagePrefix, removeLanguagePrefix } from 'utils/languageRoute';

// const defaultRedirect = `${baseUrl}/home`;

interface BaseRouteProps {
  routeUrl: RouterProps[];
  routeUrlNoSider: RouterProps[];
  catchRouteUrl: RouterProps[];
}

const BaseRoute: FC<BaseRouteProps> = (props) => {
  const location = useLocation();
  const supportedLanguages = getAllSupportedLanguageCodes();
  const currentLanguage = getLanguageFromPath(location.pathname);
  const isArcadeRoute = removeLanguagePrefix(location.pathname).startsWith('/arcade-landing');

  const routeContent = (
    <Suspense fallback={<Loading />}>
      <Switch>
        {/* 为每个路由创建带语言前缀的版本 */}
        {supportedLanguages.map((lang) =>
          props.routeUrlNoSider.map((item) => {
            const { path, component } = item;
            const langPath = addLanguagePrefix(path, lang);
            return <Route key={`${lang}-${path}`} exact path={langPath} component={component} />;
          }),
        )}

        {/* 重定向根路径到默认语言的 home 页面 */}
        <Redirect path="/" exact to={addLanguagePrefix('/home', currentLanguage || 'en')} />

        {/* 404 页面 */}
        <Route path="*" component={Error404} />
      </Switch>
    </Suspense>
  );

  return isArcadeRoute ? (
    <ArcadeLayout>{routeContent}</ArcadeLayout>
  ) : (
    <BaseLayout menu={props.routeUrlNoSider}>{routeContent}</BaseLayout>
  );
};

export default withRouter(BaseRoute);
